export default __webpack_public_path__ + "static/media/project19.eab25100.jpg";